module.exports = __webpack_public_path__ + "img/default_bg@2x.6422a530.png";